import * as api from "../Services/api.js";
import * as hub from "../Hubs/mtaHub.js";
import Appointment from "../../objs/Appointment";

export const state = {
  appointments: [],
};
export const mutations = {
  SET_APPOINTMENTS(state, payload) {
    state.appointments = payload.map((item) => new Appointment(item));
  },
  ADD_APPOINTMENT(state, payload) {
    state.appointments.push(...payload.map((item) => new Appointment(item)));
  },
  UPDATE_APPOINTMENT(state, payload) {
    state.appointments = state.appointments.map((item) => {
      return item.mtaAppointmentId === payload.mtaAppointmentId
        ? new Appointment(payload)
        : item;
    });
  },
};

export const getters = {
  getAppointmentById: (state) => (appointmentId) => {
    return state.appointments.find(
      (item) => item.mtaAppointmentId === appointmentId
    );
  },
};

export const actions = {
  async getAppointments({ commit }) {
    return await api
      .get("/MTA/getMTAAppointments")
      .then((response) => {
        if (response.success) {
          commit("SET_APPOINTMENTS", response.data);
        }
        return response.success;
      })
      .catch((error) => {
        return false;
      });
  },
  async createAppointment({ commit }, data) {
    return await api
      .post("/MTA/createMTAAppointment", data)
      .then((response) => {
        if (response.success) {
          commit("ADD_APPOINTMENT", response.data);
          return "";
        }
        return response.message;
      })
      .catch((error) => {
        return false;
      });
  },
  async updateAppointment({ commit }, data) {
    return await api
      .post("/MTA/updateMTAAppointment", data)
      .then((response) => {
        if (response.success) {
          commit("UPDATE_APPOINTMENT", response.data);
          return "";
        }
        return response.message;
      })
      .catch((error) => {
        return false;
      });
  },
  async cancelAppointment({ commit }, data) {
    return await api
      .postQuery("/MTA/cancelMTAAppointment", {
        mtaAppointmentId: data,
      })
      .then((response) => {
        if (response.success) {
          commit("UPDATE_APPOINTMENT", response.data);
          return "";
        }
        return response.message;
      })
      .catch((error) => {
        return false;
      });
  },
  async restoreAppointment({ commit }, data) {
    return await api
      .postQuery("/MTA/restoreMTAAppointment", {
        mtaAppointmentId: data,
      })
      .then((response) => {
        if (response.success) {
          commit("UPDATE_APPOINTMENT", response.data);
          return "";
        }
        return response.message;
      })
      .catch((error) => {
        return false;
      });
  },
  async exportAppointments({}, data) {
    return await api
      .postQuery("/MTA/exportMTAAppointments", data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return false;
      });
  },
  async exportIDEPAppointmentsByRequestedDate() {
    return await api
      .post("/MTA/exportIDEPAppointmentsByRequestedDate")
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return false;
      });
  },
  async sendReminder({ commit }, data) {
    return await api
      .postQuery("/MTA/sendReminder", data)
      .then((response) => {
        if (response.success) {
          commit("UPDATE_APPOINTMENT", response.data);
          return "";
        }
        return response.message;
      })
      .catch((error) => {
        return false;
      });
  },
  async uploadFiles({ commit }, data) {
    return await api
      .uploadFiles(
        "/MTA/uploadMTAAppointmentFiles",
        { mtaAppointmentId: data.mtaAppointmentId },
        data
      )
      .then((response) => {
        if (response.success) {
          commit("UPDATE_APPOINTMENT", response.data);
        }
        return response.success;
      })
      .catch((error) => {
        return false;
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
